import { AfterContentChecked, Component, ViewChild, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { InfoproductsAction } from '@toro/common/shared/state-management/infoproducts/infoproducts.action';
import { IProductGroup, IProductSpecialist } from '@toro/common/shared/interfaces/infoproducts/common.interfaces';
import { ICustomerStrategy, IAvailableStrategy } from '@toro/common/shared/interfaces/infoproducts/strategy.interfaces';
import { environment } from '../../../../../../src/environments/environment';

enum StrategiesTypes {
    MyStrategies,
    AllStrategies,
}

@AutoUnsubscribe()
@Component({
    selector: 'home-logged-strategies',
    templateUrl: './strategies.component.html',
    styleUrls: ['./strategies.component.scss'],
    providers: [],
})
export class HomeLoggedStrategiesComponent implements OnDestroy, OnInit {
    public isNewBrand = environment.isNewBrand

    public showSlides = false;
    public StrategiesTypes = StrategiesTypes;
    public filterStrategiesBy: StrategiesTypes = StrategiesTypes.AllStrategies;
    public strategiesSubscription: Subscription;

    public mostViewedStrategy: IAvailableStrategy;
    public customerStrategies: ICustomerStrategy[] = [];
    public specialistsByGroup = new Map<IProductGroup, IProductSpecialist[]>();
    public availableStrategiesByGroup = new Map<IProductGroup, IAvailableStrategy[]>();

    constructor(private store: Store<AppState>) {
        this.store.dispatch({ type: InfoproductsAction.getCustomerProducts });
        this.store.dispatch({ type: InfoproductsAction.getAvailableStrategies });
    }

    public ngOnInit() {
        this.strategiesSubscription = this.store
            .select(({ infoproducts }) => infoproducts)
            .subscribe(({ availableStrategies, customerStrategies }) => {

                this.specialistsByGroup.clear();
                this.availableStrategiesByGroup.clear();
                this.customerStrategies = Array.from(customerStrategies.values());
                availableStrategies.forEach((strategy) => {
                    if (strategy.group && strategy.group.id) {
                        const strategiesByGroup = this.availableStrategiesByGroup.get(strategy.group) || [];
                        this.availableStrategiesByGroup.set(strategy.group, [...strategiesByGroup, strategy]);
                        strategy.specialists.forEach((specialist) => {
                            const groupSpecialists = this.specialistsByGroup.get(strategy.group) || [];
                            this.specialistsByGroup.set(strategy.group, Array.from(new Set([...groupSpecialists, specialist])));
                        });
                    }
                    if (strategy.mostViewed && !this.mostViewedStrategy) {
                        this.mostViewedStrategy = strategy;
                    }
                });

            });
    }

    public ngOnDestroy() {
        // Necessary for the autounsubscribe to work
    }

    public setStrategyFilter(filterBy: StrategiesTypes) {
        this.filterStrategiesBy = filterBy;
    }
}
